import * as React from "react";
import { useDispatch, useSelector } from "react-redux";
import type { RootState } from "../../src/taskpane/components/_v2/redux/storeMain";
import { addCopilotFileSource, CopilotFileSource, removeCopilotFileSource } from "../../src/taskpane/redux/modules/copilot";

/**
 * A view whose rows can fill Specific files (`source`: the library grid, All documents, search results)
 * says so to the Copilot pane while it is open and Copilot is on here (`enabled`), and takes it back
 * when it goes: the pane's hint names that list's ways in only then, and the search and "/" elsewhere
 * (the user, 2026-10-26). With the pane closed nothing is written (the performance rule, spec
 * 2026-10-22 §2.11). A layout effect, so a pane that opens on Specific files has the right hint in its
 * first paint.
 */
export const useCopilotFileSource = (source: CopilotFileSource, enabled: boolean): void => {
  const dispatch = useDispatch();
  const isPaneOpen: boolean = useSelector((state: RootState) => state.copilot?.isPaneOpen === true);

  React.useLayoutEffect(() => {
    if (!enabled || !isPaneOpen) {
      return undefined;
    }
    dispatch(addCopilotFileSource(source));
    return () => {
      dispatch(removeCopilotFileSource(source));
    };
  }, [enabled, isPaneOpen, source]);
};
